import { cn } from '@pray/shared/utils/styles';

import Badge from '../Badge';

export default function FeatureTitle({
  title,
  icon,
  className,
  iconClassName,
}: {
  title?: string;
  icon: React.ReactElement;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <div className="flex flex-row gap-4">
      <Badge icon={icon} className={iconClassName} />
      {title && (
        <span
          className={cn(
            'self-center text-sm font-[650] tracking-wide text-[#E9BF6E] group-hover:text-gold-200 lg:text-base',
            className
          )}
        >
          {title}
        </span>
      )}
    </div>
  );
}
